var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-div"},[_c('nav',_vm._l((_vm.items),function(item,i){return (item.isAct)?_c('dropdown-view',{key:i,attrs:{"title":item.title,"currentItem":_vm.selectedItem,"titleLink":item.link,"items":item.subItems},on:{"clickItem":_vm.chooseItem}}):_vm._e()}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2039834c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteNavbar.vue
// module id = null
// module chunks = 